<template>
    <div class="gallery2 vuetified position-relative mb-5">
        <div class="w-100 overflow-hidden position-relative" :style="heightStyle">
            <div class="position-absolute d-flex flex-row justify-content-start align-items-start gallery2__wrapper" :style="styles">
                <div v-for="(image, index) of images" ref="image" class="gallery2__image" :style="imageWidth(index)">
                    <div class="position-relative">
                        <img :src="image.src" :alt="image.alt">
                        <stamp v-if="stamp.hasStamp" class="stamp--overlay" :class="stamp.stampClasses"></stamp>
                    </div>
                    <p class="h-auto w-100 mb-0 overflow-hidden" v-html="htmlText(image.alt)"></p>
                </div>
            </div>
        </div>
        <div class="gallery2__dots-container">
            <div class="dots dots--left-0 dots--size-3rem">
                <button class="dot spot-background spot-front-text border-0 rounded-circle d-flex flex-row justify-content-center align-items-center"
                        @click="next(+1)">
                    <span class="icon-right-arrow"></span>
                </button>
                <button class="dot spot-background spot-front-text border-0 rounded-circle d-flex flex-row justify-content-center align-items-center"
                        @click="next(-1)">
                    <span class="icon-left-arrow"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Stamp from '../stamp/Stamp';

    export default {
        components: {
            Stamp,
        },
        props: {
            images: {
                type: Array,
                required: true,
            },
            stamp: {
                type: Object,
                required: true,
            }
        },
        data () {
            return {
                active: 0,
                translate: 0,
                height: 400,
            }
        },
        mounted () {
            this.translate = this.calculateTranslate();
            Vue.set(this, 'height', this.calculateHeight());
        },
        computed: {
            styles () {
                return { transform: `translateX(-${this.translate}px)` }
            },
            heightStyle() {
                return { height: this.height + 'px' };
            }
        },
        methods: {
            next (value) {
                let imagesLength = this.images.length;
                this.active = (imagesLength + this.active + value) % imagesLength;
                this.translate = this.calculateTranslate();
            },
            calculateTranslate () {
                if (!this.$refs.image) return 0;

                const imagesWidthToMove = this.$refs.image.slice(0, this.active).reduce((acc, image) => {
                    return acc + $(image).outerWidth(true)
                }, 0);

                return 8 + imagesWidthToMove;
            },
            calculateHeight () {
                if (this.$refs.image) {
                    return this.$refs.image
                        .map(image => $(image))
                        .reduce((acc, $image) => {
                            return Math.max(acc, $image.height())
                        }, 0);
                } else return 0;
            },
            htmlText (text) {
                return text.replace(/\r?\n/g, '<br />');
            },
            imageWidth (index) {
                if (!this.$refs.image) return {};
                return {
                    width: $(this.$refs.image[index]).find('img').width() + 'px'
                };
            }
        }
    }
</script>
